var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMyBusiness = function SvgMyBusiness(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 198.864h-326l100 283.136h226z",
    fill: "#4175df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 198.864h226v283.136h-226z",
    fill: "#4086f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 156.75 64 86.25c0 35.346 28.654 64 64 64s64-28.654 64-64l64-86.25z",
    fill: "#609af6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 156.75v86.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-26.25z",
    fill: "#23346d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 156.75 64 86.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-86.25z",
    fill: "#324492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 216.75v26.25c0 35.346 28.654 64 64 64s64-28.654 64-64v-86.25z",
    fill: "#80aef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.24 30-65.24 186.75h128l64-93.375-31.38-93.375z",
    fill: "#9fc2f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 216.75-65.24-186.75h-95.38l-31.38 93.375 64 93.375z",
    fill: "#324492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.38 30h-95.38l-64 93.375 64 93.375h128z",
    fill: "#80aef8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.62 30-32.62 186.75h128v-186.75z",
    fill: "#4254b6"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-business.1441c26a.svg";
export { ForwardRef as ReactComponent };